<template>
  <b-container :class="isEdit ? '' : 'labels-cont'" cols="12">
    <div
      style="z-index: 10"
      class="loading-overlay"
      v-if="ngoInfo && ngoInfo.current_stage == 4"
    ></div>
    <div class="d-flex justify-content-between align-items-center">
      <h3>معلومات الحساب</h3>
      <div v-if="!accountForm.validated">
        <b-button
          class="mx-50"
          v-if="!isEdit"
          @click="isEdit = true"
          variant="info"
          >تعديل</b-button
        >
        <!-- <b-button
          :disabled="!accountForm.feedback_content"
          @click="commentsModal = true"
          variant="warning"
          >ردود الوزارة</b-button
        > -->
        <b-modal
          v-if="accountForm.feedback_content"
          size="lg"
          v-model="commentsModal"
          hide-backdrop
          footer-class="removed"
          title="رد الوزارة على معلومات الحساب"
        >
          <b-card-text class="p-1">
            <div v-html="accountForm.feedback_content"></div>
          </b-card-text>
        </b-modal>
        <template v-if="isEdit">
          <b-button @click="onCancel" variant="danger" class="mx-50"
            >الغاء</b-button
          >
          <loader-btn
            noIcon
            @click="onSave"
            variant="success"
            :loading="working"
            >حفظ</loader-btn
          >
        </template>
      </div>
      <div v-else>
        <h5 class="text-success">تمت المصادقة على معلومات الحساب</h5>
      </div>
    </div>
    <hr />
    <b-row>
      <b-col lg="4">
        <b-form-group label="الاسم الأول" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.first_name"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>

      <b-col lg="4">
        <b-form-group label="اسم الأب" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.father_name"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label="الكنية" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.last_name"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4">
        <b-form-group label="اسم المستخدم" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.username"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label="رقم الهاتف" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.phone_number"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label="الرقم الوطني" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.id_number"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label="البريد الالكتروني" label-for="price">
          <b-form-input
            id="price"
            v-model="accountForm.email"
            :plaintext="!isEdit"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BRow,
  BButton,
  BCol,
  BContainer,
  BFormGroup,
  BFormInput,
  BCardText,
} from "bootstrap-vue";

import loaderBtn from "@/components/loader-btn.vue";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { resolveUpdated } from "@/utils/utils";
import InfoCard from "@/components/InfoCard.vue";
export default {
  components: {
    BRow,
    BButton,
    BCol,
    BContainer,
    BFormGroup,
    BFormInput,
    BCardText,
    loaderBtn,
    ToastificationContent,
    InfoCard,
  },
  data() {
    return {
      isEdit: false,
      commentsModal: false,
      accountForm: {},
    };
  },
  computed: {
    ...mapGetters("TempNgo", ["ngoInfo","accountInfo", "working"]),
  },
  methods: {
    ...mapActions("TempNgo", ["updateAccountInfo"]),
    async onSave() {
      const toSave = resolveUpdated(this.accountForm, this.accountInfo);
      await this.updateAccountInfo(toSave)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت العملية بنجاح",
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch(() => {
          this.accountForm = JSON.parse(JSON.stringify(this.accountInfo));
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "خطأ",
              icon: "AlertCircleIcon",
              text: "حصل خطأ أثناء العملية",
              variant: "danger",
            },
          });
        });

      this.isEdit = false;
    },
    onCancel() {
      this.accountForm = JSON.parse(JSON.stringify(this.accountInfo));
      this.isEdit = false;
    },
  },
  mounted() {
    document.getElementsByClassName("app-content")[0].classList.add("temp-ngo");
    this.accountForm = JSON.parse(JSON.stringify(this.accountInfo));
  },
};
</script>

<style lang="scss">
.temp-ngo {
  padding-top: 5rem !important;
}
</style>
